import { render, staticRenderFns } from "./BolPhotoZoomForm.vue?vue&type=template&id=4a87508e&scoped=true"
import script from "./BolPhotoZoomForm.vue?vue&type=script&lang=js"
export * from "./BolPhotoZoomForm.vue?vue&type=script&lang=js"
import style0 from "./BolPhotoZoomForm.vue?vue&type=style&index=0&id=4a87508e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87508e",
  null
  
)

export default component.exports